import { render, staticRenderFns } from "./AddressBusiness.vue?vue&type=template&id=93a99e26&"
import script from "./AddressBusiness.vue?vue&type=script&lang=js&"
export * from "./AddressBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports